import type { StateTokens } from '../../types/mfc'
import { openError } from '../actions/openError'
import { openQuickbuyDialog } from '../app-state/modals/state.dialog'
import {
    APPSTATE,
    AppStateType,
    setAppState,
    updateAppState,
} from '../state/state.app'
import { USERSSTATE, slugToID } from '../state/state.users'
import {
    _fetchPostQuickbuy,
    _fetchPostShiftTokenStorage,
    _fetchQualifyPurchase,
    _fetchTokenConfig,
} from './api/tokens'
import { FCLEVEL_GUEST, FCLEVEL_MODEL } from './mfcConstants'
import {
    ITokenPurchaseState,
    PackageID,
    ProcessorDetails,
    ProcessorID,
    ProcessorName,
    Product,
    PurchaseInfoResponse,
    TokenProduct,
    smallPackages,
} from './tokenPurchaseOptions'
import { UserAccess } from './userProperties/level'

export async function getTokenPurchaseInfo() {
    // const config = {
    //     purchase_limits: {
    //         err: null,
    //         code: null,
    //         brief: null,
    //         description: null,
    //         daily_token_limit_amount: 11250,
    //         total_limit: 112500,
    //     },
    //     products: {
    //         '600': {
    //             id: 600,
    //             name: '200 MFC Tokens',
    //             description: '200 Tokens',
    //             amount: 19.99,
    //             volume: 200,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28063&CrossSaleOff=1&pplist=28063&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=600&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '601': {
    //             id: 601,
    //             name: '550 MFC Tokens',
    //             description: '550 Tokens',
    //             amount: 49.99,
    //             volume: 550,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28064&CrossSaleOff=1&pplist=28064&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=601&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '602': {
    //             id: 602,
    //             name: '900 MFC Tokens',
    //             description: '900 Tokens',
    //             amount: 74.99,
    //             volume: 900,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28065&CrossSaleOff=1&pplist=28065&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=602&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '603': {
    //             id: 603,
    //             name: '1875 MFC Tokens',
    //             description: '1875 Tokens',
    //             amount: 149.99,
    //             volume: 1875,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28090&CrossSaleOff=1&pplist=28090&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=603&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //         '604': {
    //             id: 604,
    //             name: '3775 MFC Tokens',
    //             description: '3775 Tokens',
    //             amount: 299.99,
    //             volume: 3775,
    //             volume_type: 'token',
    //             available: true,
    //             available_processors: [4, 9, 23, 24],
    //             purchase_urls: {
    //                 '24': 'https://secure2.segpay.com/billing/poset.cgi?x-eticketid=200520%3A28091&CrossSaleOff=1&pplist=28091&memberID=31054447&username=mbmfc_&paymentoption=pp&x-decl-link=https%3A%2F%2Fwww.myfreecams.com%2Fphp%2Fpurchase.php&x-decl-test=Click+Here+to+see+more+payment+options&product_id=604&company_id=3149&sub_company_id=0',
    //             },
    //         },
    //     },
    //     processors: {
    //         '4': {
    //             id: 4,
    //             name: 'CCBill',
    //             display_name: 'CCBill',
    //             description:
    //                 'Your card will be billed as <b>CCBill.com*Activesoft</b>.',
    //             payment_types: 'Visa, MasterCard, Discover',
    //         },
    //         '9': {
    //             id: 9,
    //             name: 'Netbilling',
    //             display_name: 'Netbilling',
    //             description:
    //                 'Your card will be billed as <b>MFCBill.com*Tokens</b>.',
    //             payment_types: 'Visa, MasterCard, Discover',
    //         },
    //         '23': {
    //             id: 23,
    //             name: 'RocketGate',
    //             display_name: 'RocketGate',
    //             description:
    //                 'Your card will be billed as <b>MFCGate.com*Tokens</b>.',
    //             payment_types: 'Visa, MasterCard, Discover',
    //         },
    //         '24': {
    //             id: 24,
    //             name: 'Segpay',
    //             display_name: 'PayPal via Segpay',
    //             description: 'Billed as <b>Segpay.com</b>',
    //             payment_types: 'PayPal',
    //         },
    //     },
    //     processor_priority: [24, 9, 23, 4],
    //     available_quickbuy_processors: [9, 23, 24],
    //     disable_in_chat_quickbuy: 0,
    //     previous_purchase: {
    //         product_id: 600,
    //         amount: 19.99,
    //         processor_id: 24,
    //         transaction_date: '2023-03-10 13:39:10',
    //         days_since: 0,
    //     },
    //     success: true,
    // }
    const config = await _fetchTokenConfig()
    const products = _getTokenProducts(config)
    return { config, products }
}

/** positive `shift` transfers tokens to storage, negative `shift` transfers tokens from storage */
export async function shiftTokenStorage(shift: number) {
    const { token } = APPSTATE.session
    const payload = { request_id: Math.random(), shift, token }
    return _fetchPostShiftTokenStorage(payload)
}

export function tokensPostQuickbuy(payload: any) {
    const { pendingQuickbuy } = APPSTATE.tokens
    const { token } = APPSTATE.session
    _setPendingQuickbuy({ ...pendingQuickbuy, processing: true })
    _fetchPostQuickbuy({ ...payload, token })
        .then(onPurchaseResponse)
        .catch((message) => openError({ message }))
}

export function tokensQualifyPurchase(payload: any) {
    _fetchQualifyPurchase(payload).then((pendingQuickbuy) => {
        openQuickbuyDialog()
        _setPendingQuickbuy(pendingQuickbuy)
    })
}

function onPurchaseResponse(purchaseResponse: any) {
    const { pendingQuickbuy } = APPSTATE.tokens
    _setPendingQuickbuy({ ...pendingQuickbuy, purchaseResponse })
}

/**
 * Build Token state based on PurchaseInfoResponse
 * @param payload PurchaseInfoResponse
 * @returns TokenPurchaseInfo
 */
function _getTokenProducts(payload: PurchaseInfoResponse) {
    const level = USERSSTATE[slugToID['me']]?.level || FCLEVEL_GUEST
    if (level === FCLEVEL_GUEST) return
    if (level === FCLEVEL_MODEL) return
    const nextTokensState = createTokenPackageState(payload, level)
    if (!nextTokensState) return
    setAppState(AppStateType.TOKENS, nextTokensState)
    return nextTokensState
}

function _setPendingQuickbuy(pendingQuickbuy: StateTokens['pendingQuickbuy']) {
    updateAppState(AppStateType.TOKENS, { pendingQuickbuy })
}

function createTokenPackageState(
    payload: PurchaseInfoResponse,
    userLevel = 0,
): ITokenPurchaseState {
    const {
        available_quickbuy_processors = [],
        processor_priority: priority = [],
        processors: processorsMap = {} as Record<ProcessorID, ProcessorDetails>,
        disable_in_chat_quickbuy = 0,
        purchase_limits: limit = {} as PurchaseInfoResponse['purchase_limits'],
        products,
    } = payload || ({} as PurchaseInfoResponse)

    const availableProcessorsByPriority = priority.map((id) => {
        const processor = processorsMap[id]
        return { ...processor }
    })

    const nextProducts: Array<TokenProduct> = Object.values(products || [])
        .filter((product: Product) => product.available)
        .map((product: Product) => {
            const {
                amount,
                available_processors,
                description,
                id,
                name,
                volume,
                volume_type,
            } = product

            const productProcessorsMap = (available_processors || []).reduce(
                (memo, id: ProcessorID) => {
                    const { [id]: processor } = processorsMap || {}

                    if (!processor) {
                        return memo
                    }

                    return { ...memo, [id]: processor }
                },
                {} as Record<ProcessorID, ProcessorDetails>,
            )

            const tokenProduct = {
                amount,
                description,
                id,
                name,
                volume,
                volume_type,
                processors: available_processors,
                processorsMap: productProcessorsMap,
            }

            return tokenProduct
        })

    const { description } = limit

    if (!products) {
        return {}
    }

    const small =
        products[PackageID.TOKENS_200] &&
        products[PackageID.TOKENS_200].available &&
        userLevel > UserAccess.MEMBER_BASIC

    const quickbuyProcessorsMap = (available_quickbuy_processors || []).reduce(
        (memo, id: ProcessorID) => {
            const { [id]: processor } = processorsMap || {}

            if (!processor) {
                return memo
            }

            return { ...memo, [id]: processor }
        },
        {} as Record<ProcessorID, ProcessorDetails>,
    )

    const tokensState: ITokenPurchaseState = {
        processorsByPriority: availableProcessorsByPriority,
        products: nextProducts,
        quickbuy: {
            processors: availableProcessorsByPriority
                .filter(({ id }) => available_quickbuy_processors.includes(id))
                .map(({ name }) => name),
            disable_in_chat: disable_in_chat_quickbuy,
            processorsMap: quickbuyProcessorsMap,
        },
        processorsMap,
        ...(small ? { smallProducts: smallPackages } : {}),
        error: typeof description === 'string' ? description.trim() : null,
    }

    return tokensState
}

export const getTokenPaymentUrl = (
    processor: ProcessorName | string,
    product: PackageID | string,
    type = '+Credit+Card',
) => {
    return (
        'https://www.myfreecams.com/php/purchase.php' +
        `?request_product=${product}${type}` +
        '&style_override=profiles' +
        '&no_cache=0.8887020342901837' +
        `&processor=${processor}` +
        '&return_url=//app.myfreecams.com' +
        '&return_title=MyFreeCams App'
    )
}
